import { render } from "./DefSlider.vue?vue&type=template&id=652ade72&scoped=true"
import script from "./DefSlider.vue?vue&type=script&lang=js"
export * from "./DefSlider.vue?vue&type=script&lang=js"

import "./DefSlider.vue?vue&type=style&index=0&id=652ade72&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652ade72"]])

export default __exports__